import React, { useEffect, useState } from 'react'
import { Popup } from 'devextreme-react/popup'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import axios from 'axios'

export default function ClickableField(props: any): JSX.Element {
	const { model, folder, field, data, onHide } = props

	const [loading, setLoading] = useState<boolean>(true)
	const [content, setContent] = useState<string>('')

	useEffect(() => {
		setLoading(true)
		axios
			.post(`${API_FIBER_URL}/view/clickable`, {
				model: model,
				folder: folder,
				field: field,
				data: data,
			})
			.then(response => {
				setContent(response.data)
				setLoading(false)
			})
	}, [folder, model, field, data])

	const renderContent = () => {
		if (loading) return <LoadIndicator id="large-indicator" height={80} width={80} />

		return <div dangerouslySetInnerHTML={{ __html: content }} />
	}

	return (
		<Popup
			visible={true}
			dragEnabled={true}
			resizeEnabled={true}
			showCloseButton={true}
			contentRender={renderContent}
			title={field}
			position="center"
			hideOnOutsideClick={() => {
				return true
			}}
			onHiding={onHide}
		/>
	)
}
